import { render, staticRenderFns } from "./pc-distribute.vue?vue&type=template&id=a2938872"
import script from "./pc-distribute.vue?vue&type=script&lang=js"
export * from "./pc-distribute.vue?vue&type=script&lang=js"
import style0 from "./pc-distribute.vue?vue&type=style&index=0&id=a2938872&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports